import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Populate extends Component {
   constructor(props){
       super(props)
         this.state = {
        question1 : "question1pittaObject",
        question2 : "question2pittaObject",
        question3 : "question3pittaObject",
        question4 : "question4pittaObject",
        question5 : "question5pittaObject",
        question6 : "question6pittaObject",
        question7 : "question7pittaObject",
        question8 : "question8pittaObject",
        question9 : "question9pittaObject",
        questio10 : "questio10pittaObject",
        results : " "
    }
    this.handleScoring2 = this.handleScoring2.bind(this);
    this.getResults = this.getResults.bind(this);
    this.submitQuiz = this.submitQuiz.bind(this);

   }
handleScoring2(event){
     const tempString = event.target.value;
    const stringQuestion = tempString.slice(0,9);
    if(stringQuestion === "question1"){
        this.setState({question1: event.target.value});
    }else if(stringQuestion === "question2"){
        this.setState({question2: event.target.value});
    }else if(stringQuestion === "question3"){
        this.setState({question3: event.target.value});
    }else if(stringQuestion === "question4"){
        this.setState({question4: event.target.value});
    }else if(stringQuestion === "question5"){
        this.setState({question5: event.target.value});
    }else if(stringQuestion === "question6"){
        this.setState({question6: event.target.value});
    }else if(stringQuestion === "question7"){
        this.setState({question7: event.target.value});
    }else if(stringQuestion === "question8"){
        this.setState({question8: event.target.value});
    }else if(stringQuestion === "question9"){
        this.setState({question9: event.target.value});
    }else if(stringQuestion === "questio10"){
        this.setState({questio10: event.target.value});
    }
   
}

         bodyCompArray = [
     {
        name: "pittaObject",
        bodyComp: " Healthy body, well-developed muscles, well-functioning metabolism",
        emotion: " Ignites into anger first, whether they show it outwardly or merely burn with it internally",
        perception: " Uses images to relate to words and emotions together",
        bodyType: " More of an Mesomorph body type",
        temperament: " High-achieving with a strong work ethic",
        weightGain: " Constant weight",
        chest: " Medium chest",
        schedule: " Long workday",
        sleep: " Sleep well, average length",
        exercise: " Competitive"
    },
     {
        name: "vataObject",
        bodyComp: " Low body weight, light bone structure, fast to act",
        emotion: " Shows fear or anxiety first",
        perception: "Most often think predominantly in words",
        bodyType: "More of an Ectomorph body type",
        temperament: " Hypersensitive to surroundings, and imaginative",
        weightGain: " 	Lose weight easily",
        chest: " Sunken, ribs showing",
        schedule: " Irregular schedule / eating times",
        sleep: " Light sleeper",
        exercise: "Prefer light exercise"
    },
   {
        name: "kaphaObject",
        bodyComp:" Heavy body weight, solid body structure, strength, endurance",
        emotion: " Avoids confrontation",
        perception: " Often thinks with their emotions and ‘feels’ the connection between words and forms",
        bodyType: " More of an Endomorph body type",
        temperament: " Peaceful, easy-going, good-natured",
        weightGain: " Gain weight easily",
        chest: " Broad, large chest",
        schedule: " Good at keeping a routine",
        sleep: " Sleep deep & long, trouble waking up",
        exercise: " Excels in most sports"
    }
    ]
getResults(vataScoreTemp, pittaScoreTemp, kaphaScoreTemp){
    vataScoreTemp = Math.ceil(vataScoreTemp/10 * 100); 
    pittaScoreTemp = Math.ceil(pittaScoreTemp/10 * 100);
    kaphaScoreTemp = Math.ceil(kaphaScoreTemp/10 * 100);
    this.setState({results : <span style={{color:"red", 
    textAlign: "center", fontSize:"2em"}}> You are {vataScoreTemp}% 
    <Link to ="/vata"> Vata</Link>, {pittaScoreTemp}% 
    <Link to ="/pitta"> Pitta</Link> , and {kaphaScoreTemp}% 
    <Link to ="/vata"> Kapha</Link>
    </span>});
    

}
submitQuiz(event){
const resultsArray = [];
let vataScoreTemp = 0;
let pittaScoreTemp = 0;
let kaphaScoreTemp = 0;
resultsArray.push(this.state.question1, this.state.question2, this.state.question3, this.state.question4,this.state.question5,this.state.question6,
    this.state.question7, this.state.question8, this.state.question9, this.state.questio10)
resultsArray.map((a)=>{ 
    const temp = a.slice(9);
   
        if(temp === "pittaObject"){
            pittaScoreTemp ++;
            this.setState({pittaScore: pittaScoreTemp});
        }else if(temp === "vataObject"){
            vataScoreTemp ++;
            this.setState({vataScore: vataScoreTemp});
        }else if(temp === "kaphaObject"){
            kaphaScoreTemp ++;
            this.setState({kaphaScore: kaphaScoreTemp});
         }else{
            console.log("err");
    }
})
this.getResults(vataScoreTemp, pittaScoreTemp, kaphaScoreTemp);
}
    render(){
        const styleRow = {
            padding : "1em",
            borderBottom : "thin solid #000000"
        }
        const styleGreyRow = {
            backgroundColor:"#f0f0f0",
            padding : "1em",
            borderBottom : "thin solid #000000"
        }
        return(
            <div className="container" style={{paddingBottom: "2em"}}>
             <div className="container" style={styleRow}>
                { this.bodyCompArray.map((data)=>{
                    const tempValue = "question1" + data.name;
                    const tempKey = "question1" + data.name;
                    return <label className="col-sm-3" key = {tempKey}><input type = "radio"  value={tempValue} checked={this.state.question1 === tempValue} 
                    onChange={this.handleScoring2} />{data.temperament}</label>
                     
                })}
                </div>
             <div className="container" style={styleGreyRow}>
                { this.bodyCompArray.map((data)=>{
                    const tempValue = "question2" + data.name;
                    const tempKey = "question2" + data.name;
                    return <label className="col-sm-3" key = {tempKey}><input type = "radio"  value={tempValue} checked={this.state.question2 === tempValue} 
                    onChange={this.handleScoring2} />{data.emotion}</label>
                     
                })}
                </div>
            <div className="container" style={styleRow}>
                { this.bodyCompArray.map((data)=>{
                    const tempValue = "question3" + data.name;
                    const tempKey = "question3" + data.name;
                    return <label className="col-sm-3" key = {tempKey}><input type = "radio"  value={tempValue} checked={this.state.question3 === tempValue} 
                    onChange={this.handleScoring2} />{data.bodyComp}</label>
                     
                })}
                </div>
            <div className="container" style={styleGreyRow}>
                { this.bodyCompArray.map((data)=>{
                    const tempValue = "question4" + data.name;
                    const tempKey = "question4" + data.name;
                    return <label className="col-sm-3" key = {tempKey}><input type = "radio"  value={tempValue} checked={this.state.question4 === tempValue} 
                    onChange={this.handleScoring2} />{data.perception}</label>
                     
                })}
                </div>
            <div className="container" style={styleRow}>
                { this.bodyCompArray.map((data)=>{
                    const tempValue = "question5" + data.name;
                    const tempKey = "question5" + data.name;
                    return <label className="col-sm-3" key = {tempKey}><input type = "radio"  value={tempValue} checked={this.state.question5 === tempValue} 
                    onChange={this.handleScoring2} />{data.bodyType}</label>
                     
                })}
                </div>
                <div className="container" style={styleGreyRow}>
                { this.bodyCompArray.map((data)=>{
                    const tempValue = "question6" + data.name;
                    const tempKey = "question6" + data.name;
                    return <label className="col-sm-3" key = {tempKey}><input type = "radio"  value={tempValue} checked={this.state.question6 === tempValue} 
                    onChange={this.handleScoring2} />{data.weightGain}</label>
                     
                })}
                </div>
                 <div className="container" style={styleRow}>
                { this.bodyCompArray.map((data)=>{
                    const tempValue = "question7" + data.name;
                    const tempKey = "question7" + data.name;
                    return <label className="col-sm-3" key = {tempKey}><input type = "radio"  value={tempValue} checked={this.state.question7 === tempValue} 
                    onChange={this.handleScoring2} />{data.chest}</label>
                     
                })}
                </div>
                 <div className="container" style={styleGreyRow}>
                { this.bodyCompArray.map((data)=>{
                    const tempValue = "question8" + data.name;
                    const tempKey = "question8" + data.name;
                    return <label className="col-sm-3" key = {tempKey}><input type = "radio"  value={tempValue} checked={this.state.question8 === tempValue} 
                    onChange={this.handleScoring2} />{data.schedule}</label>
                     
                })}
                </div>
                <div className="container" style={styleRow}>
                { this.bodyCompArray.map((data)=>{
                    const tempValue = "question9" + data.name;
                    const tempKey = "question9" + data.name;
                    return <label className="col-sm-3" key = {tempKey}><input type = "radio"  value={tempValue} checked={this.state.question9 === tempValue} 
                    onChange={this.handleScoring2} />{data.sleep}</label>
                     
                })}
                </div>
                <div className="container" style={styleRow}>
                { this.bodyCompArray.map((data)=>{
                    const tempValue = "questio10" + data.name;
                    const tempKey = "questio10" + data.name;
                    return <label className="col-sm-3" key = {tempKey}><input type = "radio"  value={tempValue} checked={this.state.questio10 === tempValue} 
                    onChange={this.handleScoring2} />{data.exercise}</label>
                     
                })}
                </div>
                <div className = "container" style = {{ paddingBottom:"2em"}}>{this.state.results}</div>
                <button id="submit" onClick={this.submitQuiz} className="btn btn-primary" >Submit</button>
                </div>
        )
    }
}
class Quiz extends Component {

    render(){
       
        return (
        <div>
            <div className="col-sm-2">
                </div>
                <div className="col-sm-8">
                    <h4>Quiz is a bad word. There is no grade here. This is simply a way for you to find out 
                        what dosha you are most dominant in. Please keep in mind that it is common to have 
                        traits of several doshas. Everyone is different and you have to find out what works for you.
                    </h4>
                 <hr />
                </div>
            <div className="col-sm-2">
                </div>
                <Populate />
        </div>)
    }
}

 export default Quiz;


// WEBPACK FOOTER //
// ./src/components/quiz.js